import NumAbbr from 'number-abbreviate'
const numAbbr = new NumAbbr(['k', 'm', 'b', 't', 'q'])

export default function numberWithCommas(x: number | string): string | undefined {
	if (x === 0) {
		return '0'
	}

	if (!x || x == 'Infinity') {
		return
	}

	const int = parseInt(String(x))

	if (!isNaN(int) && int > 100_000_000) {
		return numAbbr.abbreviate(int, 2).toUpperCase()
	}

	if (!isNaN(Number(x)) && Number(x) > 100_000_000_000_000_000) {
		return Number(x).toExponential(1)
	}

	const split = x.toString().split('.')
	const decimals = split[1] ? split[1].slice(0, 6) : ''
	const value = split[0]

	const res = `${value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${
		decimals ? `.${decimals}` : ''
	}`

	if (res === 'NaN') {
		return '0'
	}

	return res
}
